"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateExperimentResponseToJSON = exports.CreateExperimentResponseFromJSONTyped = exports.CreateExperimentResponseFromJSON = exports.instanceOfCreateExperimentResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateExperimentResponse interface.
 */
function instanceOfCreateExperimentResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateExperimentResponse = instanceOfCreateExperimentResponse;
function CreateExperimentResponseFromJSON(json) {
    return CreateExperimentResponseFromJSONTyped(json, false);
}
exports.CreateExperimentResponseFromJSON = CreateExperimentResponseFromJSON;
function CreateExperimentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
    };
}
exports.CreateExperimentResponseFromJSONTyped = CreateExperimentResponseFromJSONTyped;
function CreateExperimentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.CreateExperimentResponseToJSON = CreateExperimentResponseToJSON;
